// extracted by mini-css-extract-plugin
module.exports = {"nautilusTab":"NautilusTab_nautilusTab__1fbGB"};